/** Specific vocabulary to be used to give repeatable content a distinct brand voice
 * @example
 * import { HabitatVocab } from '@sainsburys-tech/vocab'
 *
 * return (
 *   <Button>{ HabitatVocab.ADD_TO_TROLLEY }</Button>
 * )
 * @example
 * const Button = () => {
 * const { ADD_TO_TROLLEY } = useVocab()
 * return (
 *   <Button>{ ADD_TO_TROLLEY }</Button>
 * )
 */
const HabitatVocab = {
  BRAND_NAME: 'Habitat',
  ADD_TO_TROLLEY: 'Add to bag',
  ITEM_CONTAINER: 'bag'
}

export default HabitatVocab
